import React, { useState } from 'react';
import {
  IonApp,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonSearchbar,
  IonSplitPane,
  IonMenu,
  IonButton,
  IonButtons,
  IonList,
  IonListHeader,
  IonMenuToggle,
  IonItem,
  IonIcon,
  IonLabel,
} from '@ionic/react';
import { menu } from 'ionicons/icons';
import PostList from '../components/post/PostList';

export default function Posts({ latest, top }) {
  const [searchText, setSearchText] = useState('');
  const [topics] = useState([
    'General',
    'Data Structures',
    'Algorithms',
    'Web Technologies',
    'Machine Learning',
    'Data Science',
    'Cryptography',
  ]);

  return (
    <IonApp>
      <IonSplitPane when='sm' contentId='main-content'>
        <IonMenu contentId='main-content'>
          <IonHeader>
            <IonToolbar color='primary'>
              <IonTitle className='title'>
                <h5 className='title'>Posts</h5>
              </IonTitle>
            </IonToolbar>
          </IonHeader>

          <IonContent>
            <IonSearchbar value={searchText} onIonChange={(e) => setSearchText(e.detail.value)} animated></IonSearchbar>
            <IonList>
              <IonListHeader>
                <h1 className='title'>
                  <strong>Topics</strong>
                </h1>
              </IonListHeader>
              {topics.map((topic) => (
                <IonMenuToggle autoHide={false}>
                  <IonItem button onClick={() => setSearchText(topic)}>
                    <IonLabel>{topic}</IonLabel>
                  </IonItem>
                </IonMenuToggle>
              ))}
            </IonList>
          </IonContent>
        </IonMenu>

        <div className='ion-page' id='main-content'>
          <IonToolbar color='secondary'>
            <IonButtons slot='start'>
              <IonMenuToggle>
                <IonButton>
                  <IonIcon slot='icon-only' icon={menu}></IonIcon>
                </IonButton>
              </IonMenuToggle>
            </IonButtons>
          </IonToolbar>
          <IonContent className='ion-padding'>
            <PostList filter={searchText} />
          </IonContent>
        </div>
      </IonSplitPane>
    </IonApp>
  );
}
